module.exports = __webpack_public_path__ + "img/sofort.3328a401.svg";